var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56791 14.9599C11.699 14.9599 15.0479 11.611 15.0479 7.47991C15.0479 3.34882 11.699 -9.15527e-05 7.56791 -9.15527e-05C3.43682 -9.15527e-05 0.0878906 3.34882 0.0878906 7.47991C0.0878906 11.611 3.43682 14.9599 7.56791 14.9599Z",
    fill: "#E5E8EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37464 7.48106C9.37464 6.48252 8.56674 5.67461 7.56819 5.67461C6.56965 5.67461 5.76172 6.48252 5.76172 7.48106C5.76172 8.47961 6.56965 9.28752 7.56819 9.28752C8.56674 9.28752 9.37464 8.47961 9.37464 7.48106Z",
    fill: "#BFBFB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDot);
export default __webpack_public_path__ + "static/media/gray_dot.d7d9521e118c6b08f54bb7a2e076d540.svg";
export { ForwardRef as ReactComponent };